export default "__VITE_ASSET__aa02620f__"